export default "__VITE_ASSET__DYQVL7JX__"